import { jsx } from 'react/jsx-runtime';
import { themedColor, useViewportSize, Backdrop } from '@lemonade-hq/cdk';
import { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { useAnalyticsContext } from '../../providers/AnalyticsProvider.esm.js';
import { useVisitorContext } from '../../providers/VisitorProvider.esm.js';
import { useUserContext } from '../../providers/UserProvider.esm.js';
import { Client } from '../../helpers/client/client.esm.js';

/* eslint-disable react/iframe-missing-sandbox */ function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n  border-radius: 6px;\n  background-color: ",
        ";\n  user-select: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var IFRAME_DESKTOP_WIDTH = 408;
var IFRAME_DESKTOP_HEIGHT = 266;
var IFRAME_MOBILE_WIDTH = 350;
var IFRAME_MOBILE_HEIGHT = 248;
var LOGIN_IFRAME_SUCCESS_MESSAGE = "lemonade::login_success";
var StyledIframe = styled.iframe(_templateObject(), themedColor("white"));
var LoginIframe = function(param) {
    var onSuccess = param.onSuccess, loginUrl = param.loginUrl, userInfoUrl = param.userInfoUrl;
    var register = useAnalyticsContext().register;
    var visitorEmail = useVisitorContext().visitorEmail;
    var _useUserContext = useUserContext(), user = _useUserContext.user, updateUser = _useUserContext.updateUser;
    var isMobileViewport = useViewportSize().isMobileViewport;
    var iframeWidth = isMobileViewport ? IFRAME_MOBILE_WIDTH : IFRAME_DESKTOP_WIDTH;
    var iframeHeight = isMobileViewport ? IFRAME_MOBILE_HEIGHT : IFRAME_DESKTOP_HEIGHT;
    useEffect(function() {
        var _window_top;
        var handler = function(event) {
            if (event.data === LOGIN_IFRAME_SUCCESS_MESSAGE) {
                if (userInfoUrl != null) {
                    Client.get(userInfoUrl).then(function(userInfo) {
                        updateUser(userInfo);
                        register(userInfo);
                    }).catch(function() {
                    // do nothing, it's fine to fail gracefully here, and we don't want to throw an error
                    });
                }
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            }
        };
        (_window_top = window.top) === null || _window_top === void 0 ? void 0 : _window_top.addEventListener("message", handler);
        return function() {
            var _window_top;
            (_window_top = window.top) === null || _window_top === void 0 ? void 0 : _window_top.removeEventListener("message", handler);
        };
    }, [
        onSuccess,
        updateUser,
        userInfoUrl,
        register
    ]);
    var finalLoginUrl = useMemo(function() {
        var url = new URL(loginUrl !== null && loginUrl !== void 0 ? loginUrl : "/");
        url.searchParams.append("iframe", "true");
        if ((user === null || user === void 0 ? void 0 : user.email) != null || visitorEmail != null) {
            var _user_email, _ref;
            url.searchParams.append("email", (_ref = (_user_email = user === null || user === void 0 ? void 0 : user.email) !== null && _user_email !== void 0 ? _user_email : visitorEmail) !== null && _ref !== void 0 ? _ref : "");
        }
        return url.toString();
    }, [
        loginUrl,
        visitorEmail,
        user
    ]);
    return /*#__PURE__*/ jsx(Backdrop, {
        disablesBodyScroll: true,
        children: /*#__PURE__*/ jsx(StyledIframe, {
            height: iframeHeight,
            src: finalLoginUrl,
            style: {
                width: "".concat(iframeWidth, "px"),
                height: "".concat(iframeHeight, "px")
            },
            title: "login",
            width: iframeWidth
        })
    });
};

export { LOGIN_IFRAME_SUCCESS_MESSAGE, LoginIframe };
